export default "__VITE_ASSET__008909c5__"